/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StaffGradedIcon = /*#__PURE__*/ createSvgIcon(
  'StaffGradedIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} fill="currentColor">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.998 9.989C5.24 9.724 5.58 9.57 6 9.57h.173l.135.106a.97.97 0 00.66.205l.035-.002.034.002a.93.93 0 00.65-.201l.137-.11H8c.42 0 .761.152 1.008.412.232.245.35.55.413.818.106.445.088.936.081 1.13A2.362 2.362 0 009.5 12h-1l.003-.15c.006-.222.015-.526-.054-.82-.042-.175-.102-.292-.166-.36a.295.295 0 00-.146-.085 1.93 1.93 0 01-1.14.296 1.97 1.97 0 01-1.131-.295.26.26 0 00-.131.079c-.059.064-.115.177-.152.354-.06.283-.048.564-.039.786.003.072.006.138.006.195h-1l-.003-.071c-.01-.191-.034-.684.058-1.118.056-.266.166-.575.393-.822zM7.09 7.01a.5.5 0 100 1 .5.5 0 000-1zm-1.5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM.5 8a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.5 3.51h4.706L11.5 5.792l.01 6.207-1 .002-.01-5.793L8.794 4.51H5.5v1.5h-1v-2.5z"
            />
            <path d="M8.5 4.02L11 6.46H8.5V4.02z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM.5 10a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z" />
            <path d="M5.63 12.093c.312-.34.75-.543 1.31-.543h.174l.136.108c.311.246.7.371 1.096.353l.024-.002.024.002a1.64 1.64 0 001.096-.353l.136-.108H9.8c.55 0 .98.207 1.287.545.29.321.442.729.525 1.1.137.614.112 1.289.101 1.59a4.164 4.164 0 00-.003.125h-1c0-.058.002-.13.005-.21.01-.328.025-.819-.08-1.287-.063-.286-.161-.505-.29-.647a.63.63 0 00-.396-.206 2.64 2.64 0 01-1.579.45 2.64 2.64 0 01-1.58-.45.659.659 0 00-.423.209c-.128.14-.224.355-.284.638-.096.452-.076.913-.061 1.244.004.1.008.187.008.259h-1c0-.027-.002-.072-.005-.133-.015-.302-.048-.974.08-1.577.078-.373.228-.784.525-1.107zM8.36 8.86a.73.73 0 100 1.46.73.73 0 000-1.46zm-1.73.73a1.73 1.73 0 113.46 0 1.73 1.73 0 01-3.46 0z" />
            <path d="M6.23 3.77h4.797l3.563 3.563v7.577h-1V7.747L10.613 4.77H7.23v1.96h-1V3.77z" />
            <path d="M11.32 7.04V4.27h-1v3.77h3.77v-1h-2.77z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M12 1.5C6.2 1.5 1.5 6.201 1.5 12S6.2 22.5 12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5zM.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.35 23.5 12 23.5.5 18.351.5 12z" />
            <path d="M7.354 15.36c.359-.393.863-.63 1.516-.63h.176l.137.11c.4.32.902.484 1.414.46h.046a2.11 2.11 0 001.414-.46l.137-.11h.176c.643 0 1.14.24 1.493.631.338.374.518.852.617 1.297.165.738.137 1.543.124 1.919l-.004.163h-1c0-.067.002-.15.005-.246.013-.402.032-1.025-.1-1.617-.08-.36-.207-.65-.383-.845a.894.894 0 00-.597-.294 3.11 3.11 0 01-1.905.562 3.11 3.11 0 01-1.906-.562.92.92 0 00-.62.296c-.176.192-.3.479-.375.837-.12.572-.096 1.163-.078 1.57.005.116.009.218.009.299h-1c0-.038-.003-.099-.007-.179-.017-.378-.054-1.176.098-1.897.094-.447.27-.928.613-1.304zM10.62 11.23a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0z" />
            <path d="M8.12 5.23h5.708l4.282 4.293v9.207h-1V9.937L13.413 6.23H9.12v2.5h-1v-3.5z" />
            <path d="M14.12 9.23v-3.5h-1v4.5h4.49v-1h-3.49z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default StaffGradedIcon;
